/* eslint-disable @typescript-eslint/no-explicit-any */
import { OrchestrationApi } from "./api";

export const UpdateConfiguration = async (
    serviceId: string,
    configuration: any
): Promise<any> => {
    const api = await OrchestrationApi();
    const apiResponse = await api
        .post(`dashboard-ui/configuration`, { serviceId, configuration })
        .then((result) => {
            return result;
        });

    return apiResponse;
};
